export const SignerParticipantStatus = Object.freeze({
  SIGNED: "signed",
  REJECTED: "rejected",
});
